import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { createSubscriptionFailed, createSubscriptionSuccessful } from '../actions';
import { CREATED } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* createSubscription(action) {
  try {
    const body = action.payload;
    const url = `${BACKEND_URL}/proxy/subscription/v1/subscriptions`;
    const dataResponse = yield makeRequest(url, body, action, 'POST', true);
    if (dataResponse.status === CREATED) {
      const data = yield dataResponse.json();
      const createdSubscription = data?.data || data || {};
      yield put(createSubscriptionSuccessful(createdSubscription));
      yield call(resolveActionPromise(action, createdSubscription));
    } else {
      const data = yield dataResponse.json();
      yield put(createSubscriptionFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createSubscriptionFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
